import { Trans } from '@lingui/macro';
import { useEffect, useState } from 'react';
import { RoomCall } from '../../models/RoomCall';
import { Fire } from '../../services/FireClient';
import { My } from '../../services/My';
import { twil } from '../../services/TwilioHelper';
import { CallTitleBadge } from './CallInfoItems';
// import ProfileImg from './ProfileImg'; // Assuming ProfileImg is simple or can be replaced.
import UserPopOver from './UserPopover';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from '../../components/ui/avatar';
import { Card } from '../../components/ui/card';
import { Util } from '../../services/Utils/Util';

const RejoinRoomCallModal: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [joinedCalls, setJoinedCalls] = useState<RoomCall[]>([]);

  useEffect(() => {
    Fire.call.getJoinedRoomCalls(My.user.id).then(calls => {
      setJoinedCalls(calls);
      setShowModal(calls.length > 0);
    });
  }, [])

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="sm:max-w-md [&>button]:hidden">
        <DialogHeader>
          <DialogTitle><Trans>You still appear in a voice call.</Trans></DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {joinedCalls.map(call => (
            <Card key={call.id} className="p-4 border shadow-sm">
              <div className="flex flex-col gap-4">
                <div className="flex items-center flex-wrap gap-2">
                  {CallTitleBadge(`#${call.room.name}`, call.userIds.length, false)}
                  <div className="flex -space-x-2">
                    {call.users.map(u => (
                      <UserPopOver
                        user={u}
                        key={u.id}
                        content={
                          <Avatar className="w-8 h-8 border-2 border-transparent cursor-pointer">
                            <AvatarImage src={u.photoUrl || Util.ANONYMOUS_PHOTO_URL} />
                            <AvatarFallback>{u.name?.charAt(0)}</AvatarFallback>
                          </Avatar>
                        }
                      />
                    ))}
                  </div>
                </div>

                <div className="text-sm text-muted-foreground text-center">
                  <Trans>Choose an option</Trans>
                </div>

                <div className="flex flex-col gap-2">
                  <Button onClick={() => joinCall(call)} className="w-full bg-blue-600 hover:bg-blue-700 text-on-primary-text">
                    <Trans>Join from here</Trans>
                  </Button>
                  <Button onClick={() => setShowModal(false)} variant="outline" className="w-full">
                    <Trans>I'm using another device</Trans>
                  </Button>
                  <Button onClick={() => leaveCall(call)} variant="ghost" className="w-full text-destructive hover:text-destructive hover:bg-destructive/10">
                    <Trans>I have already left</Trans>
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )

  function leaveCall(call: RoomCall) {
    if (joinedCalls.length == 1) {
      setShowModal(false);
    } else {
      setJoinedCalls(joinedCalls.filter(c => c.id != call.id));
    }
    Fire.call.leaveRoomCall(call.id, My.user.id);
  }

  function joinCall(call: RoomCall) {
    setShowModal(false);
    twil.join(call.room, My.user.id);
  }
}
export default RejoinRoomCallModal;
